module.exports = __webpack_public_path__ + "img/正方形.af7bdf65.png";